import { DataModel } from "common/models/utility-models/base-model"

export class RegisterStep1Model extends DataModel {
    firstName:any=''
    middleName:any=''
    lastName:any=''
    fullName:any=''
    gender:any=''
    age:any=''
    mobileNumber:any=''
    landlineNumber:any=''
    email:any=''
    alternativeEmail:any=''
    city:any=''
    stateId:any=[]
    district_id:any=''
}